











































































import { Component, Prop, Vue } from 'vue-property-decorator'
import { Action, Getter, State } from 'vuex-class'

import {
  CreatePortionModal,
  InfiniteScroll,
  PortionTile,
  NetworkErrorEmptyState,
  VsLoading
} from '@/components'

import { EmptyState, MobileLayout } from '@/layouts/components'

import {
  AsyncState,
  ModalState,
  Portion,
  PortionOuterContext
} from '@/models'

import { ItemPortions } from '@/store/menu/state'
import { RelationMap } from '@/store/models'
import { RootState } from '@/store/state'

@Component({
  components: {
    CreatePortionModal,
    EmptyState,
    InfiniteScroll,
    PortionTile,
    MobileLayout,
    NetworkErrorEmptyState,
    VsLoading
  }
})
export default class Portions extends Vue {
  @Prop({ type: Number, required: true })
  readonly itemId!: number

  @Prop({ type: Number, required: true })
  readonly itemGroupId!: number

  loadState = new AsyncState()
  createState = new ModalState()

  get itemPortions (): ItemPortions | undefined {
    return this.itemsPortions[this.itemId]
  }

  get portions () {
    return this.orderedPortions(this.itemId)
  }

  get showFab () {
    return this.total > 0 || this.loadState.isResolved
  }

  get total () {
    return this.itemPortions
      ? this.itemPortions.total
      : 0
  }

  @State((state: RootState) => state.menu.items.portions)
  readonly itemsPortions!: RelationMap<ItemPortions>

  @Getter('menu/orderedPortions')
  readonly orderedPortions!: (itemId: number) => Portion[]

  @Action('menu/loadPortionPage')
  loadPortionPage!: (context: PortionOuterContext) => Promise<void>

  created () {
    if (this.total === 0) {
      this.reload()
    } else {
      this.loadState.touch()
    }
  }

  async reload () {
    try {
      await this.loadMore()
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(e)
    }
  }

  async loadMore () {
    await this.loadState.handle(
      this.loadPortionPage({
        itemId: this.itemId,
        itemGroupId: this.itemGroupId
      })
    )

    return this.portions.length > 0
  }
}
